import React from "react";
import { KeylessModal } from "./KeylessModal";
import { keylessColors } from "../utils";
import icoInfoOrange from "../../../assets/images/ico-info-orange.svg";

export function KeylessWarningModal({ isOpen, title, message, buttonText = "Entendido", onClose }) {
  return (
    <KeylessModal
      isOpen={isOpen}
      img={icoInfoOrange}
      title={title}
      message={message}
      actions={
        <button onClick={onClose} style={styles.button}>
          {buttonText}
        </button>
      }
    />
  );
}

const styles = {
  button: {
    width: "100%",
    height: "7vh",
    borderRadius: "8px",
    fontSize: "1.2rem",
    outline: "none",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "white",
    backgroundColor: keylessColors.orange,
  },
};
